import { Input } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const InviteInfoForm = styled.div`
  width: 458px;

  ${DEVICE.mobile.max} {
    width: 100%;
  }
`;

const InviteInfoFormHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const InviteInfoFormGroups = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
  padding: 40px;

  ${DEVICE.mobile.max} {
    padding: 24px;
    width: 100%;
  }
`;

const InviteInfoFormGroup = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 8px;

  ${Input.S?.Base} {
    width: calc(50% - 4px);
  }

  ${DEVICE.mobile.max} {
    flex-direction: column;

    ${Input.S?.Base} {
      width: 100%;
    }
  }
`;
const InviteInfoFormFooter = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
`;

export {
  InviteInfoForm,
  InviteInfoFormFooter,
  InviteInfoFormGroup,
  InviteInfoFormGroups,
  InviteInfoFormHeader
};
